export enum CommonGenericEvents {
	LINK_SELECTED = 'click_footer',
	SHOW = 'show_footer',
}
